"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MaxArray = MaxArray;
exports.MinArray = MinArray;
exports.convolve = convolve;
exports.cosh = cosh;
exports.getBaseLog = getBaseLog;
exports.getLogMidPoint = getLogMidPoint;
exports.inverseFourier = inverseFourier;
exports.logBaseTen = logBaseTen;
exports.sinh = sinh;
function sinh(number) {
  var x = number;
  var expNumber = Math.exp(x);
  var expNegNumber = Math.exp(-x);
  var sinhNumber = (expNumber - expNegNumber) / 2;
  return sinhNumber;
}
function cosh(number) {
  var x = number;
  var expNumber = Math.exp(x);
  var expNegNumber = Math.exp(-x);
  var coshNumber = (expNumber + expNegNumber) / 2;
  return coshNumber;
}
function logBaseTen(your_log) {
  var result = Math.log(your_log) / Math.log(10);
  return result;
}
function getBaseLog(x, y) {
  return Math.log(y) / Math.log(x);
}
function convolve(xArr, yArr) {
  var resultArray = [];
  var nLength = xArr.length;
  var mLength = yArr.length;
  for (var i = 0, j = 0; i < mLength; i++) {
    var result = 0;
    for (var k = 0; k < nLength; k++) {
      j = i - k;
      if (j >= 0 && j < mLength) result += xArr[k] * yArr[j];else break;
    }
    resultArray[i] = result;
  }
  return resultArray;
}
function getLogMidPoint(maxVal, minVal) {
  var val = 0;
  var avg = (this.logBaseTen(maxVal) + this.logBaseTen(minVal)) / 2;
  val = Math.pow(10, avg);
  return val;
}
function MaxArray(array) {
  return Math.max.apply(Math, array);
}
function MinArray(array) {
  return Math.min.apply(Math, array);
}
function inverseFourier(complexFreqDomainArray, freqStep, numTimePoints, expectedEndPoint) {
  var freqDomainLength = complexFreqDomainArray.length;
  var pi = Math.PI;
  var xArray = [];
  var yArrayImpulse = [];
  var yArrayStep = [];
  var timestep = 1 / (freqStep * complexFreqDomainArray.length);
  var integrationSum = 0;
  for (var i = 0; i < numTimePoints; i++) {
    var runningSum = 0;
    for (var j = 0; j < freqDomainLength; j++) {
      //set up multiplier, which has magnitude 1 and varying phase. (i.e imagine corkscrew)
      //number of multipler cycles would equal j, if we used symetrical frequency domain array
      //however to save calculations we don't mirror frequency array.
      //So # of multipler cycles is j/2. This means we set up phase with pi, rather than pi/2
      var multiplier_phase = pi * i * j / freqDomainLength;
      var multiplier_real = Math.cos(multiplier_phase);
      var multiplier_imag = Math.sin(multiplier_phase);
      var result_real = multiplier_real * complexFreqDomainArray[j].real - multiplier_imag * complexFreqDomainArray[j].imaginary;
      runningSum += result_real;
    }
    xArray.push(i * timestep / 2);
    yArrayImpulse.push(runningSum / freqDomainLength);
    if (i !== 0) {
      integrationSum += (yArrayImpulse[i] + yArrayImpulse[i - 1]) / 2;
      yArrayStep.push(integrationSum);
    } else {
      yArrayStep.push(0);
    }
  }
  var endPointError = yArrayStep[yArrayStep.length - 1] - expectedEndPoint;
  var errorCorrection = endPointError / numTimePoints;
  yArrayStep = [];
  integrationSum = 0;
  for (i = 0; i < numTimePoints; i++) {
    yArrayImpulse[i] -= errorCorrection;
    if (i !== 0) {
      integrationSum += (yArrayImpulse[i] + yArrayImpulse[i - 1]) / 2;
      yArrayStep.push(integrationSum);
    } else {
      yArrayStep.push(0);
    }
  }
  return [xArray, yArrayStep, yArrayImpulse];
}

// NOT used
// PRIVATE FUNCTIONS
// function asinh(arg) {
//     return Math.log(arg + Math.sqrt(arg * arg + 1));
// }

// function aCosh(arg) {
//     return Math.log(arg + Math.sqrt(arg * arg - 1));
// }